import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  src: 'https://cdn.magicpatterns.com/uploads/iemqw5FkViKkxfdp2pBviu/testimonio_1.jpg',
  amount: '$1.663.150'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rgLm2SkmFtnQcg9Je9cade/testimonio_2.jpg',
  amount: '$691.710'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3PAoVmUdwvUZZSsaDFaaNx/testimonio_3.jpg',
  amount: '$695.680'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2dPEH4dLMR1hZVHco9nZtv/WhatsApp_Image_2026-05-25_at_15.18.37.jpg',
  amount: '$239.540 · 38% conv.'
}];
export function Testimonials() {
  return <section className="py-12 md:py-16 bg-dark-800/50 border-y border-white/5" data-id="element-291">
      <div className="container mx-auto px-4" data-id="element-292">
        <div className="text-center mb-8 md:mb-10" data-id="element-293">
          <h2 className="text-gold-500 font-display text-base md:text-2xl tracking-widest uppercase mb-2 md:mb-3 flex items-center justify-center gap-2" data-id="element-294">
            <TrendingUpIcon size={18} data-id="element-295" /> Resultados Reales
          </h2>
          <p className="text-2xl md:text-4xl font-display text-white uppercase tracking-wide leading-tight" data-id="element-296">
            Capturas, no promesas
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5 max-w-6xl mx-auto" data-id="element-297">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} whileHover={{
          y: -4
        }} className="bg-dark-900 rounded-xl border-gold-subtle overflow-hidden hover:border-gold-500/50 transition-colors group flex flex-col" data-id="element-298">
              <div className="relative aspect-[3/4] bg-[#0d0d0d] overflow-hidden flex items-center justify-center" data-id="element-299">
                <img src={t.src} alt={`Captura de resultado ${t.amount}`} loading="lazy" decoding="async" width="600" height="800" className="w-full h-full object-contain" data-id="element-300" />
              </div>
              <div className="p-2 md:p-3 border-t border-gold-500/10 flex items-center gap-1.5 justify-center bg-dark-900" data-id="element-301">
                <BadgeCheckIcon className="text-gold-500 w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" data-id="element-302" />
                <span className="text-gold-400 text-[11px] md:text-sm font-bold tracking-wide" data-id="element-303">
                  {t.amount} facturados
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}